import qs from 'qs';
import { buildQuery, hostFromSelection, type EditorState } from '@xsscool/shared';

export { buildQuery };

export interface ShareUrlOptions {
  domainBase: string;
  domainSub?: string;
}

function isProductionHost(): boolean {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  if (!h || h === 'localhost') return false;
  if (/^\d+\.\d+\.\d+\.\d+$/.test(h)) return false;
  if (/^[0-9a-f:]+$/i.test(h)) return false;
  if (h.endsWith('.local') || h.endsWith('.test')) return false;
  return true;
}

export function buildShareUrl(state: EditorState, opts: ShareUrlOptions): string {
  const queryString = qs.stringify(buildQuery(state), {
    encodeValuesOnly: true,
    arrayFormat: 'repeat',
  });
  const suffix = queryString ? `?${queryString}` : '';

  // Dev/test fallback: when the editor isn't loaded at a public host,
  // generate URLs against the current origin so they stay reachable.
  if (!isProductionHost()) {
    if (typeof window === 'undefined') return suffix || '/';
    const { protocol, hostname, port } = window.location;
    const target = port === '5173' ? `${protocol}//${hostname}:8080` : window.location.origin;
    return `${target}${suffix || '/'}`;
  }

  const host = hostFromSelection({ base: opts.domainBase, sub: opts.domainSub });
  return `https://${host}${suffix || '/'}`;
}
